export default "__VITE_ASSET__D7_C$GTT__"